module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-impressed.4498fea2.png";